// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1OVfG","boxTitle":"Qualiphy_boxTitle__2WOnO","box":"Qualiphy_box__1DcLL","toggleWrap":"Qualiphy_toggleWrap__3OenD"};